<template>
  <div :key="topBarKey" class="topbar">
    <!-- <div v-if="!this.$store.getters.name" class="nav"> -->
    <div v-if="!company" class="nav">
      <span class="welcomeText">您好！欢迎光临实达实 </span>
      <ul>
        <!-- @mouseenter="loginMove(1)" @mouseleave="loginLeave()" -->
        <li class="notLogin">
          <router-link to="/">
            <!-- @click="toHome" -->
            <span class="toHome">首页</span>
          </router-link>
          <router-link :to="{ path: '/login/login' }">登录</router-link>
          <!-- 登录 -->
          <div v-if="isLogin === 1" class="login-box">
            <div class="loginId">
              <div class="login-up" />
              <div class="button" @mouseenter="loginButtomMove(1)" @mouseleave="loginButtonLeave()">
                <svg-icon v-if="isLoginButton !== 1" class="svgIcon" icon-class="gongying-black" />
                <svg-icon v-if="isLoginButton === 1" class="svgIcon" icon-class="gongying-red" />
                <a :href="path" target="_blank" :class="isLoginButton == 1 ? 'activeId' : ''">我要供应</a>
              </div>
              <div class="button" @mouseenter="loginButtomMove(3)" @mouseleave="loginButtonLeave()">
                <svg-icon v-if="isLoginButton !== 3" class="svgIcon" icon-class="caigou-black" />
                <svg-icon v-if="isLoginButton === 3" class="svgIcon" icon-class="caigou-red" />
                <span @click="toLogin">
                  <router-link :to="{ path: '/login/login' }" :class="isLoginButton == 3 ? 'activeId' : ''">我要采购
                  </router-link>
                </span>
              </div>
            </div>
          </div>
        </li>
        <!-- @mouseenter="loginMove(2)" @mouseleave="loginLeave()" -->
        <li class="notLogin">
          <router-link :to="{ path: '/login/register' }">免费注册</router-link>
          <!-- 免费注册 -->
          <div v-if="isLogin === 2" class="registeLogin-box">
            <div class="loginId registeLogin">
              <div class="login-up" />
              <div class="button" @mouseenter="loginButtomMove(2)" @mouseleave="loginButtonLeave()">
                <svg-icon v-if="isLoginButton !== 2" icon-class="gongying-black" />
                <svg-icon v-if="isLoginButton === 2" icon-class="gongying-red" />
                <a :href="path + 'register'" target="_blank">我要供应</a>
              </div>
              <div class="button" @mouseenter="loginButtomMove(4)" @mouseleave="loginButtonLeave()">
                <svg-icon v-if="isLoginButton !== 4" icon-class="caigou-black" />
                <svg-icon v-if="isLoginButton === 4" icon-class="caigou-red" />
                <router-link :to="{ path: '/login/register' }">我要采购</router-link>
              </div>
            </div>
          </div>
        </li>
        <li class="notLogin" @click="toSupplier(1)">
          供应商登录
        </li>
        <li class="notLogin" style="font-family: DIN; font-weight: bold">
          <router-link :to="{ path: '/login/register' }">
            <svg-icon icon-class="phone" />
            0570-3088009
          </router-link>
        </li>
      </ul>
    </div>
    <div v-else class="loginNav">
      <div>
        <span class="welcomeText">您好！欢迎光临实达实 </span>
      </div>
      <!-- <div v-if="this.$store.getters.name"> -->
      <div>
        <ul>
          <li>
            <span slot="reference" class="reference">
              <svg-icon icon-class="avatar" />
              <!-- {{ this.$store.getters.name }} -- {{ company }} -->
              <!-- {{ showName }} -->
              {{ company }}
            </span>
            <span class="loginOut" @click="logout"> 退出登录 </span>
            <!-- <router-link to="/"> -->
            <!-- @click="toHome" -->
            <span class="toHome" @click="toHome">首页</span>
            <!-- </router-link> -->
            <!-- <el-popover v-model="visible" placement="top" width="180">
              <p>确定退出登录吗？</p>
              <div style="text-align: right; margin: 10px 0 0">
                <el-button size="mini" type="text" style="color:#EC212D;" @click="visible = false">取消</el-button>
                <el-button type="danger" size="mini" style="background-color:#EC212D;" @click="logout">确定</el-button>
              </div>

            </el-popover> -->
          </li>
          <li v-if="showRoutes('在线充值')">
            <router-link to="">在线充值</router-link>
          </li>
          <li v-if="showRoutes('订单管理')">
            <router-link to="/order/orderManagement">订单管理</router-link>
          </li>
          <!-- <li v-if="showRoutes('快速求购')">
            <router-link to="/buy/postBuyLeads">快速求购</router-link>
          </li> -->
          <li v-if="showRoutes('帮助中心')">
            <router-link to="/help/helpCenter">帮助中心</router-link>
          </li>
          <!-- <li>
            <el-dropdown trigger="click">
              <div>
                <span v-if="showRoutes('用户中心')">用户中心</span>
                <svg-icon class="svg-icon" icon-class="down" style="margin-left: 3px" />
              </div>
              <el-dropdown-menu slot="dropdown" class="user-dropdown">
                <span v-for="(item, index) in routerList" :key="index">
                  <router-link :to="{ path: item.redirect }">
                    <el-dropdown-item>
                      {{ item.name }}
                    </el-dropdown-item>
                  </router-link>
                </span>
              </el-dropdown-menu>
            </el-dropdown>
          </li> -->
          <li>
            <span class="phone-number">
              <svg-icon icon-class="phone" style="margin-right: 7px" />0570-3088009
            </span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import LoginButton from '@/components/LoginButton/index.vue'
import path from '@/utils/path.js'
import { mapGetters } from 'vuex'
export default {
  components: {
    // LoginButton
  },
  data() {
    return {
      visible: false,
      isLogin: null, // 是否显示登录注册
      isLoginButton: null,
      path,
      //   company: '',
      showName: '',
      topBarKey: 0
    }
  },
  watch: {
    company(val) {
      console.log(val)
    //   this.topBarKey++
    //   this.$forceUpdate()
    }
  },
  computed: {
    ...mapGetters(['company', 'routeGather']),
    showRoutes() {
      const settingRoute = this.routeGather.filter(item => !item.hidden).map(items => items.meta.title)
      return function(val) {
        return settingRoute.indexOf(val) > -1
      }
    },
    routerList() {
      return this.routeGather.filter(
        (item) => item.showHome
      )
    }
  },
  mounted() {
    // this.company = sessionStorage.getItem('company')
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    userInfo && this.$store.commit('user/SET_COMPANY', `${userInfo.fuserName}--${userInfo.funitName}`)
  },
  methods: {
    toSupplier(n) {
      const h = window.location.hostname
      if(path){
         window.open(path)
      }
      if (h === 'sdsmallcs.caishen.cn' || h === 'localhost') {
        const a = n ? 'http://sdssupply.caishen.cn/index.html#/login' : 'http://sdssupply.caishen.cn/index.html#/register'
        window.open(a)
      } else if (h === 'mall.sds18.com' || h === 'www.sds18.com') {
        const a = n ? 'https://supplier.sds18.com/index.html#/login' : 'https://supplier.sds18.com/index.html#/register'
        window.open(a)
      }
    },
    toHome() {
      const isShoping = this.$route.query.isShoping
      this.$router.push({
        path: '/Home',
        query: {
          isShoping
        }
      })
    },
    toLogin() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
      if (keys) {
        for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
      }
      this.$router.push({ path: '/login/login' })
    },
    // 退出登录
    logout() {
      this.$confirm('您确定要退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const headerSearch = this.$parent.$parent.$refs.headerSearch
          headerSearch && (headerSearch.isShoping = true, headerSearch.FIsAgree = headerSearch.FShowAllStock = 0)
          // 清空本地登录信息
          localStorage.removeItem('userInfo')
          this.$store.commit('user/SET_NAME', '')
          this.$store.commit('user/SET_TOKEN', '')
          this.$store.commit('user/CUSTOMER', '')
          this.$store.commit('user/SET_COMPANY', '')
          //   this.$store.commit('user/CUSTOMER', '')
          sessionStorage.removeItem('vuex')
          var keys = document.cookie.match(/[^ =;]+(?=\=)/g)
          if (keys) {
            for (var i = keys.length; i--;) { document.cookie = keys[i] + '=0;expires=' + new Date(0).toUTCString() }
          }
          // 清空vuex登录信息
          // this.setUser('')
          if (this.$route.name == 'Home') {
            this.$parent.$parent.getLogo()
          }
          this.notifySucceed('成功退出登录')
          this.$router.push({ path: '/Home' })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录'
          })
        })
    },
    loginButtomMove(index) {
      this.isLoginButton = index
    },
    loginButtonLeave() {
      this.isLoginButton = ''
    },
    loginMove(index) {
      this.isLogin = index
    },
    loginLeave() {
      this.isLogin = ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/shopIndex.scss";

/* 顶部导航栏CSS */
.loginOut {
  margin-left: 10px;
  color: #ec212d !important;
}
.toHome {
    margin: 0 15px;
    color: #ec212d !important;
}
.topbar .loginNav  .phone-number{
  font-size: 14px;
font-family: Microsoft YaHei-Bold, Microsoft YaHei;
font-weight: bold;
color: #EC212D;
}
.reference {
  color: #ec212d !important;
}

.topbar {
  height: 40px;
  background-color: #f4f4f4;
}

.topbar ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
}

.topbar .nav,
.topbar .loginNav {
  width: 100%;
  height: 100%;
  display: flex;
  width:1219px;
  margin:auto;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 10px;
}
.topbar .welcomeText {
  font-size: 14px;
  color: #666666;
  font-family: SimSun;
  line-height: 40px;
}

.topbar .loginNav li .topbar .nav li {
  float: left;
  height: 40px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  color: #ec212d;
}

.topbar .loginNav span,
.topbar .loginNav li {
  color: #333;
  cursor: pointer;
  font-size: 14px;
}

.topbar .nav li:nth-child(1)::before {
  content: none;
}

.topbar .nav li:after,
.topbar .loginNav li::after {
  content: "|";
  color: #ccc;
  width: 2px;
  height: 5px;
  margin: 0 10px;
}

.topbar .nav li:last-child::after,
.topbar .loginNav li:last-child::after {
  content: none;
}

.topbar .nav ul .notLogin {
  font-size: 14px;
  font-family: SimSun;
  color: #ec212d;
  position: relative;
}

.login-box {
  width: 160px;
  height: 100px;
  position: absolute;
  top: 18px;
  right: -35px;
}

.registeLogin-box {
  width: 160px;
  height: 100px;
  position: absolute;
  top: 18px;
  right: -22px;
}

.loginId {
  position: absolute;
  width: 160px;
  height: 83px;
  top: 10px;
  background-color: #ffffff;
  box-shadow: 0px 1px 8px #7a7373;
  font-size: 16px;
  font-family: SimSun;
  font-weight: 400;
  background-size: cover;
  z-index: 20;

  .svgIcon {
    margin-right: 7px;
  }
}

.activeId {
  color: #ec212d;
}

/* 顶部导航栏CSS END */
</style>
<style lang="scss">
.notLogin {
    cursor: pointer;
}
.notLogin .el-button {
  border: none;
  background-color: none;
  padding: 0;
  color: #ec212d;
}

* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}
</style>
